<div class="group" appActionOnOutsideClick (clickOutside)="close()">
  <label>{{ 'country.option.label' | translate }}</label>
  <div class="selected-item" [ngClass]="showCountry ? 'arrow-down' : ''">
    <div
      class="option"
      [ngClass]="countryOptionsGroup.invalid ? 'invalid' : 'valid'"
      [class.dirty]="countryOptionsGroup.dirty"
    >
      <input
        type="button"
        name="group"
        data-testid="country-toggle"
        (click)="toggleShowingCountry()"
      />
      <p *ngIf="countryOptionsGroup.value?.country">
        {{ countryOptionsGroup.value.country }}
      </p>
      <p class="placeholder" *ngIf="!countryOptionsGroup.value.country">
        {{ 'country.option.placeholder' | translate }}
      </p>
    </div>
  </div>
  <div
    class="option-wrap"
    [ngClass]="showCountry ? 'active' : ''"
    appTypeAheadFocus
  >
    <div
      class="option children"
      *ngFor="let option of countryOptions"
      [formGroup]="countryOptionsGroup"
    >
      <input
        type="radio"
        name="country"
        [attr.data-testid]="'country-option-' + option.title"
        [formControlName]="'country'"
        (click)="toggleShowingCountry()"
        [value]="option.title"
      />
      <p>{{ option.title }}</p>
    </div>
  </div>
  <div
    *ngIf="
      countryOptionsGroup.invalid && !showCountry && countryOptionsGroup.dirty
    "
    [class.dirty]="countryOptionsGroup.dirty"
    class="error-message"
  >
    <div>{{ 'country.option.error.required' | translate }}</div>
  </div>
</div>
